<div class="flxClmn bs-enabled">
	<div class="page-title-container flxClmn-center">
		<div class="page-title-inner-container">
			<span class="page-title">Plan Settings</span>
		</div>
		<div class="page-subtitle-container">
			<span class="page-subtitle">Email flow integration, domains, region and integrations</span>
		</div>
	</div>
	<div class="page-inner-content-holder gap-3 pt-0 flex-column" [ngClass]="{'no-scroll' : gs.getTabName() === dic.CONSTANTS.outboundPlanSettingsPageTabs.domains}">
		<!--Tabs-->
		<div class="md-tabs" [ngStyle]="{'--md-tabs-width': tabWidth + 'px'}">
			<div *ngFor="let tab of dic.CONSTANTS.outboundPlanSettingsPageTabs | keyvalue: gs.returnZero"
				 [ngClass]="{'selected' : gs.getTabName() === tab.value}"
				 [routerLink]="tab.value" queryParamsHandling="preserve">
				<input type="radio" name="tabs" id="{{tab.key}}Toggle" [checked]="gs.getTabName() === tab.value">
				<label for="{{tab.key}}Toggle">{{tab.value | camelCaseToTitleCase}}</label>
			</div>

			<div class="slide" [ngStyle]="{'left' : tabWidth * _.values(dic.CONSTANTS.outboundPlanSettingsPageTabs).indexOf(gs.getTabName()) + 'px' || 0}"></div>
		</div>
		<!---->

		<router-outlet></router-outlet>
	</div>
</div>

